import React from "react";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import { useNavigate } from "react-router-dom";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  p: 0,
  overflow: 'hidden',
};

function PromptModal({ open, onClose, message, title = "Notice", linkText, linkPath }) {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    if (linkPath) {
      navigate(linkPath);
      onClose();
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="prompt-modal-title"
      aria-describedby="prompt-modal-description"
    >
      <Paper sx={style}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pt: 3,
            px: 3,
            pb: 2,
          }}
        >
          <Typography variant='h3'>{title}</Typography>
          <IconButton
            onClick={onClose}
            sx={{
              p: 0.25,
              color: 'border.dark'
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            px: 3,
            pb: 3,
            textAlign: 'left'
          }}
        >
          <Typography variant='body1' mb={2}>
            {linkText ? (
              message.split(linkText).map((part, index) => (
                <React.Fragment key={index}>
                  {part}
                  {index < message.split(linkText).length - 1 && (
                    <span
                      onClick={handleLinkClick}
                      style={{
                        color: '#1976d2',
                        cursor: 'pointer',
                        textDecoration: 'underline'
                      }}
                    >
                      {linkText}
                    </span>
                  )}
                </React.Fragment>
              ))
            ) : (
              message
            )}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 3,
            pb: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              minWidth: 100
            }}
          >
            OK
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
}

export default PromptModal;